import type { AppData, LegacyAppData, WorkDay } from "./types"

/**
 * Migrates legacy localStorage data to the new format
 * 
 * Legacy format: { employees: Employee[], remoteDays: RemoteDay[] }
 * New format: { employees: Employee[], workDays: WorkDay[] }
 * 
 * @param data - Raw data from localStorage (may be legacy or new format)
 * @returns Migrated data in new format
 */
export function migrateData(data: any): AppData {
  // Check if data is already in new format
  if (data.workDays !== undefined) {
    return data as AppData
  }
  
  // Check if data is in legacy format with remoteDays
  if (data.remoteDays !== undefined) {
    
    const legacy = data as LegacyAppData
    
    // Convert remoteDays to workDays with status='remote'
    const workDays: WorkDay[] = legacy.remoteDays.map(rd => ({
      id: rd.id,
      userId: rd.userId,
      date: rd.date,
      status: 'remote' as const
    }))

    
    return {
      employees: legacy.employees,
      workDays
    }
  }
  
  return {
    employees: data.employees || [],
    workDays: []
  }
}

